// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PricingMatrixRouteImport } from './routes/pricing-matrix'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as SitemapHtmlRouteImport } from './routes/sitemap-html'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as AreasIndexRouteImport } from './routes/areas/index'
import { Route as AreasAreaRouteImport } from './routes/areas/$area'
import { Route as BangkokIndexRouteImport } from './routes/bangkok/index'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies/index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies/$slug'
import { Route as CompareIndexRouteImport } from './routes/compare/index'
import { Route as CompareSlugRouteImport } from './routes/compare/$slug'
import { Route as ConsularLegalizationIndexRouteImport } from './routes/consular-legalization/index'
import { Route as CountriesIndexRouteImport } from './routes/countries/index'
import { Route as EmbassiesIndexRouteImport } from './routes/embassies/index'
import { Route as EmbassiesCodeRouteImport } from './routes/embassies/$code'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as EnCatalogRouteImport } from './routes/en/catalog'
import { Route as ForIndexRouteImport } from './routes/for/index'
import { Route as ForSegmentRouteImport } from './routes/for/$segment'
import { Route as GlossaryIndexRouteImport } from './routes/glossary/index'
import { Route as GlossaryTermRouteImport } from './routes/glossary/$term'
import { Route as HowtoIndexRouteImport } from './routes/howto/index'
import { Route as HowtoSlugRouteImport } from './routes/howto/$slug'
import { Route as IndustrialEstatesIndexRouteImport } from './routes/industrial-estates/index'
import { Route as InsightsIndexRouteImport } from './routes/insights/index'
import { Route as InsightsSlugRouteImport } from './routes/insights/$slug'
import { Route as LocationsIndexRouteImport } from './routes/locations/index'
import { Route as LocationsBranchRouteImport } from './routes/locations/$branch'
import { Route as NaatiIndexRouteImport } from './routes/naati/index'
import { Route as NearIndexRouteImport } from './routes/near/index'
import { Route as NearPlaceRouteImport } from './routes/near/$place'
import { Route as NotaryIndexRouteImport } from './routes/notary/index'
import { Route as PoaIndexRouteImport } from './routes/poa/index'
import { Route as PoliceClearanceIndexRouteImport } from './routes/police-clearance/index'
import { Route as PoliceClearanceCountryRouteImport } from './routes/police-clearance/$country'
import { Route as ProvincesIndexRouteImport } from './routes/provinces/index'
import { Route as RecommendIndexRouteImport } from './routes/recommend/index'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesServiceRouteImport } from './routes/services/$service'
import { Route as ToolsRankDashboardRouteImport } from './routes/tools/rank-dashboard'
import { Route as TranslationIndexRouteImport } from './routes/translation/index'
import { Route as TranslationLangRouteImport } from './routes/translation/$lang'
import { Route as BangkokDistrictIndexRouteImport } from './routes/bangkok/$district.index'
import { Route as BangkokDistrictServiceRouteImport } from './routes/bangkok/$district.$service'
import { Route as BusinessFaqIndexRouteImport } from './routes/business/faq.index'
import { Route as BusinessFaqCategoryRouteImport } from './routes/business/faq.$category'
import { Route as CivilRegistryFaqIndexRouteImport } from './routes/civil-registry/faq.index'
import { Route as CivilRegistryFaqCategoryRouteImport } from './routes/civil-registry/faq.$category'
import { Route as CompanyFaqIndexRouteImport } from './routes/company/faq.index'
import { Route as CompanyFaqCategoryRouteImport } from './routes/company/faq.$category'
import { Route as CompanyTypeIndexRouteImport } from './routes/company/type.index'
import { Route as CompanyTypeTypeRouteImport } from './routes/company/type.$type'
import { Route as ConsularLegalizationCountryCountryRouteImport } from './routes/consular-legalization/country.$country'
import { Route as ConsularLegalizationDocumentDocRouteImport } from './routes/consular-legalization/document.$doc'
import { Route as ConsularLegalizationFaqIndexRouteImport } from './routes/consular-legalization/faq.index'
import { Route as ConsularLegalizationFaqCategoryRouteImport } from './routes/consular-legalization/faq.$category'
import { Route as CorporateDocsFaqIndexRouteImport } from './routes/corporate-docs/faq.index'
import { Route as CorporateDocsFaqCategoryRouteImport } from './routes/corporate-docs/faq.$category'
import { Route as CountriesCountryIndexRouteImport } from './routes/countries/$country.index'
import { Route as CountriesCountryServiceRouteImport } from './routes/countries/$country.$service'
import { Route as DrivingFaqIndexRouteImport } from './routes/driving/faq.index'
import { Route as DrivingFaqCategoryRouteImport } from './routes/driving/faq.$category'
import { Route as EducationFaqIndexRouteImport } from './routes/education/faq.index'
import { Route as EducationFaqCategoryRouteImport } from './routes/education/faq.$category'
import { Route as EmploymentFaqIndexRouteImport } from './routes/employment/faq.index'
import { Route as EmploymentFaqCategoryRouteImport } from './routes/employment/faq.$category'
import { Route as EnConsularLegalizationIndexRouteImport } from './routes/en/consular-legalization/index'
import { Route as EnInsightsIndexRouteImport } from './routes/en/insights/index'
import { Route as EnInsightsSlugRouteImport } from './routes/en/insights/$slug'
import { Route as EnNaatiIndexRouteImport } from './routes/en/naati/index'
import { Route as EnNotaryIndexRouteImport } from './routes/en/notary/index'
import { Route as EnPoaIndexRouteImport } from './routes/en/poa/index'
import { Route as EnPoliceClearanceIndexRouteImport } from './routes/en/police-clearance/index'
import { Route as EnPoliceClearanceCountryRouteImport } from './routes/en/police-clearance/$country'
import { Route as EnServicesIndexRouteImport } from './routes/en/services/index'
import { Route as EnServicesServiceRouteImport } from './routes/en/services/$service'
import { Route as EnTranslationIndexRouteImport } from './routes/en/translation/index'
import { Route as IndustrialEstatesEstateIndexRouteImport } from './routes/industrial-estates/$estate.index'
import { Route as IndustrialEstatesEstateServiceRouteImport } from './routes/industrial-estates/$estate.$service'
import { Route as InheritanceFaqIndexRouteImport } from './routes/inheritance/faq.index'
import { Route as InheritanceFaqCategoryRouteImport } from './routes/inheritance/faq.$category'
import { Route as InsuranceFaqIndexRouteImport } from './routes/insurance/faq.index'
import { Route as InsuranceFaqCategoryRouteImport } from './routes/insurance/faq.$category'
import { Route as InterpreterFaqIndexRouteImport } from './routes/interpreter/faq.index'
import { Route as InterpreterFaqCategoryRouteImport } from './routes/interpreter/faq.$category'
import { Route as IpFaqIndexRouteImport } from './routes/ip/faq.index'
import { Route as IpFaqCategoryRouteImport } from './routes/ip/faq.$category'
import { Route as LegalFaqIndexRouteImport } from './routes/legal/faq.index'
import { Route as LegalFaqCategoryRouteImport } from './routes/legal/faq.$category'
import { Route as MarriageFaqIndexRouteImport } from './routes/marriage/faq.index'
import { Route as MarriageFaqCategoryRouteImport } from './routes/marriage/faq.$category'
import { Route as MedicalFaqIndexRouteImport } from './routes/medical/faq.index'
import { Route as MedicalFaqCategoryRouteImport } from './routes/medical/faq.$category'
import { Route as NaatiDocumentDocRouteImport } from './routes/naati/document.$doc'
import { Route as NaatiFaqIndexRouteImport } from './routes/naati/faq.index'
import { Route as NaatiFaqCategoryRouteImport } from './routes/naati/faq.$category'
import { Route as NaatiProvinceProvinceRouteImport } from './routes/naati/province.$province'
import { Route as NaatiVisaSubclassRouteImport } from './routes/naati/visa.$subclass'
import { Route as NotaryCountryCountryRouteImport } from './routes/notary/country.$country'
import { Route as NotaryDocumentDocRouteImport } from './routes/notary/document.$doc'
import { Route as NotaryFaqIndexRouteImport } from './routes/notary/faq.index'
import { Route as NotaryFaqCategoryRouteImport } from './routes/notary/faq.$category'
import { Route as NotaryProvinceProvinceRouteImport } from './routes/notary/province.$province'
import { Route as PensionFaqIndexRouteImport } from './routes/pension/faq.index'
import { Route as PensionFaqCategoryRouteImport } from './routes/pension/faq.$category'
import { Route as PoaFaqIndexRouteImport } from './routes/poa/faq.index'
import { Route as PoaFaqCategoryRouteImport } from './routes/poa/faq.$category'
import { Route as PoaJurisdictionCountryRouteImport } from './routes/poa/jurisdiction.$country'
import { Route as PoliceClearanceFaqIndexRouteImport } from './routes/police-clearance/faq.index'
import { Route as PoliceClearanceFaqCategoryRouteImport } from './routes/police-clearance/faq.$category'
import { Route as PoliceClearanceProvinceProvinceRouteImport } from './routes/police-clearance/province.$province'
import { Route as PropertyFaqIndexRouteImport } from './routes/property/faq.index'
import { Route as PropertyFaqCategoryRouteImport } from './routes/property/faq.$category'
import { Route as ProvincesProvinceIndexRouteImport } from './routes/provinces/$province.index'
import { Route as ProvincesProvinceServiceRouteImport } from './routes/provinces/$province.$service'
import { Route as RecommendHubIndexRouteImport } from './routes/recommend/$hub/index'
import { Route as RecommendHubTopicRouteImport } from './routes/recommend/$hub/$topic'
import { Route as RelocationFaqIndexRouteImport } from './routes/relocation/faq.index'
import { Route as RelocationFaqCategoryRouteImport } from './routes/relocation/faq.$category'
import { Route as TaxFaqIndexRouteImport } from './routes/tax/faq.index'
import { Route as TaxFaqCategoryRouteImport } from './routes/tax/faq.$category'
import { Route as TranslationCountryCountryRouteImport } from './routes/translation/country.$country'
import { Route as TranslationDocumentDocRouteImport } from './routes/translation/document.$doc'
import { Route as TranslationFaqIndexRouteImport } from './routes/translation/faq.index'
import { Route as TranslationFaqCategoryRouteImport } from './routes/translation/faq.$category'
import { Route as VehicleFaqIndexRouteImport } from './routes/vehicle/faq.index'
import { Route as VehicleFaqCategoryRouteImport } from './routes/vehicle/faq.$category'
import { Route as VisaFaqIndexRouteImport } from './routes/visa/faq.index'
import { Route as VisaFaqCategoryRouteImport } from './routes/visa/faq.$category'
import { Route as VisaThaiIndexRouteImport } from './routes/visa/thai.index'
import { Route as VisaThaiTypeRouteImport } from './routes/visa/thai.$type'
import { Route as WorkPermitFaqIndexRouteImport } from './routes/work-permit/faq.index'
import { Route as WorkPermitFaqCategoryRouteImport } from './routes/work-permit/faq.$category'
import { Route as WorkPermitTypeIndexRouteImport } from './routes/work-permit/type.index'
import { Route as WorkPermitTypeTypeRouteImport } from './routes/work-permit/type.$type'
import { Route as EnBusinessFaqIndexRouteImport } from './routes/en/business/faq.index'
import { Route as EnBusinessFaqCategoryRouteImport } from './routes/en/business/faq.$category'
import { Route as EnCivilRegistryFaqIndexRouteImport } from './routes/en/civil-registry/faq.index'
import { Route as EnCivilRegistryFaqCategoryRouteImport } from './routes/en/civil-registry/faq.$category'
import { Route as EnCompanyFaqIndexRouteImport } from './routes/en/company/faq.index'
import { Route as EnCompanyFaqCategoryRouteImport } from './routes/en/company/faq.$category'
import { Route as EnCompanyTypeIndexRouteImport } from './routes/en/company/type.index'
import { Route as EnCompanyTypeTypeRouteImport } from './routes/en/company/type.$type'
import { Route as EnConsularLegalizationCountryCountryRouteImport } from './routes/en/consular-legalization/country.$country'
import { Route as EnConsularLegalizationDocumentDocRouteImport } from './routes/en/consular-legalization/document.$doc'
import { Route as EnConsularLegalizationFaqIndexRouteImport } from './routes/en/consular-legalization/faq.index'
import { Route as EnConsularLegalizationFaqCategoryRouteImport } from './routes/en/consular-legalization/faq.$category'
import { Route as EnCorporateDocsFaqIndexRouteImport } from './routes/en/corporate-docs/faq.index'
import { Route as EnCorporateDocsFaqCategoryRouteImport } from './routes/en/corporate-docs/faq.$category'
import { Route as EnDrivingFaqIndexRouteImport } from './routes/en/driving/faq.index'
import { Route as EnDrivingFaqCategoryRouteImport } from './routes/en/driving/faq.$category'
import { Route as EnEducationFaqIndexRouteImport } from './routes/en/education/faq.index'
import { Route as EnEducationFaqCategoryRouteImport } from './routes/en/education/faq.$category'
import { Route as EnEmploymentFaqIndexRouteImport } from './routes/en/employment/faq.index'
import { Route as EnEmploymentFaqCategoryRouteImport } from './routes/en/employment/faq.$category'
import { Route as EnInheritanceFaqIndexRouteImport } from './routes/en/inheritance/faq.index'
import { Route as EnInheritanceFaqCategoryRouteImport } from './routes/en/inheritance/faq.$category'
import { Route as EnInsuranceFaqIndexRouteImport } from './routes/en/insurance/faq.index'
import { Route as EnInsuranceFaqCategoryRouteImport } from './routes/en/insurance/faq.$category'
import { Route as EnInterpreterFaqIndexRouteImport } from './routes/en/interpreter/faq.index'
import { Route as EnInterpreterFaqCategoryRouteImport } from './routes/en/interpreter/faq.$category'
import { Route as EnIpFaqIndexRouteImport } from './routes/en/ip/faq.index'
import { Route as EnIpFaqCategoryRouteImport } from './routes/en/ip/faq.$category'
import { Route as EnLegalFaqIndexRouteImport } from './routes/en/legal/faq.index'
import { Route as EnLegalFaqCategoryRouteImport } from './routes/en/legal/faq.$category'
import { Route as EnMarriageFaqIndexRouteImport } from './routes/en/marriage/faq.index'
import { Route as EnMarriageFaqCategoryRouteImport } from './routes/en/marriage/faq.$category'
import { Route as EnMedicalFaqIndexRouteImport } from './routes/en/medical/faq.index'
import { Route as EnMedicalFaqCategoryRouteImport } from './routes/en/medical/faq.$category'
import { Route as EnNaatiDocumentDocRouteImport } from './routes/en/naati/document.$doc'
import { Route as EnNaatiFaqIndexRouteImport } from './routes/en/naati/faq.index'
import { Route as EnNaatiFaqCategoryRouteImport } from './routes/en/naati/faq.$category'
import { Route as EnNaatiProvinceProvinceRouteImport } from './routes/en/naati/province.$province'
import { Route as EnNaatiVisaSubclassRouteImport } from './routes/en/naati/visa.$subclass'
import { Route as EnNotaryCountryCountryRouteImport } from './routes/en/notary/country.$country'
import { Route as EnNotaryDocumentDocRouteImport } from './routes/en/notary/document.$doc'
import { Route as EnNotaryFaqIndexRouteImport } from './routes/en/notary/faq.index'
import { Route as EnNotaryFaqCategoryRouteImport } from './routes/en/notary/faq.$category'
import { Route as EnNotaryProvinceProvinceRouteImport } from './routes/en/notary/province.$province'
import { Route as EnPensionFaqIndexRouteImport } from './routes/en/pension/faq.index'
import { Route as EnPensionFaqCategoryRouteImport } from './routes/en/pension/faq.$category'
import { Route as EnPoaFaqIndexRouteImport } from './routes/en/poa/faq.index'
import { Route as EnPoaFaqCategoryRouteImport } from './routes/en/poa/faq.$category'
import { Route as EnPoaJurisdictionCountryRouteImport } from './routes/en/poa/jurisdiction.$country'
import { Route as EnPoliceClearanceFaqIndexRouteImport } from './routes/en/police-clearance/faq.index'
import { Route as EnPoliceClearanceFaqCategoryRouteImport } from './routes/en/police-clearance/faq.$category'
import { Route as EnPoliceClearanceProvinceProvinceRouteImport } from './routes/en/police-clearance/province.$province'
import { Route as EnPropertyFaqIndexRouteImport } from './routes/en/property/faq.index'
import { Route as EnPropertyFaqCategoryRouteImport } from './routes/en/property/faq.$category'
import { Route as EnRelocationFaqIndexRouteImport } from './routes/en/relocation/faq.index'
import { Route as EnRelocationFaqCategoryRouteImport } from './routes/en/relocation/faq.$category'
import { Route as EnTaxFaqIndexRouteImport } from './routes/en/tax/faq.index'
import { Route as EnTaxFaqCategoryRouteImport } from './routes/en/tax/faq.$category'
import { Route as EnTranslationCountryCountryRouteImport } from './routes/en/translation/country.$country'
import { Route as EnTranslationDocumentDocRouteImport } from './routes/en/translation/document.$doc'
import { Route as EnTranslationFaqIndexRouteImport } from './routes/en/translation/faq.index'
import { Route as EnTranslationFaqCategoryRouteImport } from './routes/en/translation/faq.$category'
import { Route as EnVehicleFaqIndexRouteImport } from './routes/en/vehicle/faq.index'
import { Route as EnVehicleFaqCategoryRouteImport } from './routes/en/vehicle/faq.$category'
import { Route as EnVisaFaqIndexRouteImport } from './routes/en/visa/faq.index'
import { Route as EnVisaFaqCategoryRouteImport } from './routes/en/visa/faq.$category'
import { Route as EnVisaThaiIndexRouteImport } from './routes/en/visa/thai.index'
import { Route as EnVisaThaiTypeRouteImport } from './routes/en/visa/thai.$type'
import { Route as EnWorkPermitFaqIndexRouteImport } from './routes/en/work-permit/faq.index'
import { Route as EnWorkPermitFaqCategoryRouteImport } from './routes/en/work-permit/faq.$category'
import { Route as EnWorkPermitTypeIndexRouteImport } from './routes/en/work-permit/type.index'
import { Route as EnWorkPermitTypeTypeRouteImport } from './routes/en/work-permit/type.$type'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CatalogRoute = CatalogRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PricingMatrixRoute = PricingMatrixRouteImport.update({
            id: '/pricing-matrix',path: '/pricing-matrix',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const SitemapHtmlRoute = SitemapHtmlRouteImport.update({
            id: '/sitemap-html',path: '/sitemap-html',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const AreasIndexRoute = AreasIndexRouteImport.update({
            id: '/areas/',path: '/areas/',getParentRoute: () => rootRouteImport
          })
const AreasAreaRoute = AreasAreaRouteImport.update({
            id: '/areas/$area',path: '/areas/$area',getParentRoute: () => rootRouteImport
          })
const BangkokIndexRoute = BangkokIndexRouteImport.update({
            id: '/bangkok/',path: '/bangkok/',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/case-studies/',path: '/case-studies/',getParentRoute: () => rootRouteImport
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/case-studies/$slug',path: '/case-studies/$slug',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const ConsularLegalizationIndexRoute = ConsularLegalizationIndexRouteImport.update({
            id: '/consular-legalization/',path: '/consular-legalization/',getParentRoute: () => rootRouteImport
          })
const CountriesIndexRoute = CountriesIndexRouteImport.update({
            id: '/countries/',path: '/countries/',getParentRoute: () => rootRouteImport
          })
const EmbassiesIndexRoute = EmbassiesIndexRouteImport.update({
            id: '/embassies/',path: '/embassies/',getParentRoute: () => rootRouteImport
          })
const EmbassiesCodeRoute = EmbassiesCodeRouteImport.update({
            id: '/embassies/$code',path: '/embassies/$code',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const EnCatalogRoute = EnCatalogRouteImport.update({
            id: '/en/catalog',path: '/en/catalog',getParentRoute: () => rootRouteImport
          })
const ForIndexRoute = ForIndexRouteImport.update({
            id: '/for/',path: '/for/',getParentRoute: () => rootRouteImport
          })
const ForSegmentRoute = ForSegmentRouteImport.update({
            id: '/for/$segment',path: '/for/$segment',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossaryTermRoute = GlossaryTermRouteImport.update({
            id: '/glossary/$term',path: '/glossary/$term',getParentRoute: () => rootRouteImport
          })
const HowtoIndexRoute = HowtoIndexRouteImport.update({
            id: '/howto/',path: '/howto/',getParentRoute: () => rootRouteImport
          })
const HowtoSlugRoute = HowtoSlugRouteImport.update({
            id: '/howto/$slug',path: '/howto/$slug',getParentRoute: () => rootRouteImport
          })
const IndustrialEstatesIndexRoute = IndustrialEstatesIndexRouteImport.update({
            id: '/industrial-estates/',path: '/industrial-estates/',getParentRoute: () => rootRouteImport
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => rootRouteImport
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => rootRouteImport
          })
const LocationsIndexRoute = LocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => rootRouteImport
          })
const LocationsBranchRoute = LocationsBranchRouteImport.update({
            id: '/locations/$branch',path: '/locations/$branch',getParentRoute: () => rootRouteImport
          })
const NaatiIndexRoute = NaatiIndexRouteImport.update({
            id: '/naati/',path: '/naati/',getParentRoute: () => rootRouteImport
          })
const NearIndexRoute = NearIndexRouteImport.update({
            id: '/near/',path: '/near/',getParentRoute: () => rootRouteImport
          })
const NearPlaceRoute = NearPlaceRouteImport.update({
            id: '/near/$place',path: '/near/$place',getParentRoute: () => rootRouteImport
          })
const NotaryIndexRoute = NotaryIndexRouteImport.update({
            id: '/notary/',path: '/notary/',getParentRoute: () => rootRouteImport
          })
const PoaIndexRoute = PoaIndexRouteImport.update({
            id: '/poa/',path: '/poa/',getParentRoute: () => rootRouteImport
          })
const PoliceClearanceIndexRoute = PoliceClearanceIndexRouteImport.update({
            id: '/police-clearance/',path: '/police-clearance/',getParentRoute: () => rootRouteImport
          })
const PoliceClearanceCountryRoute = PoliceClearanceCountryRouteImport.update({
            id: '/police-clearance/$country',path: '/police-clearance/$country',getParentRoute: () => rootRouteImport
          })
const ProvincesIndexRoute = ProvincesIndexRouteImport.update({
            id: '/provinces/',path: '/provinces/',getParentRoute: () => rootRouteImport
          })
const RecommendIndexRoute = RecommendIndexRouteImport.update({
            id: '/recommend/',path: '/recommend/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesServiceRoute = ServicesServiceRouteImport.update({
            id: '/services/$service',path: '/services/$service',getParentRoute: () => rootRouteImport
          })
const ToolsRankDashboardRoute = ToolsRankDashboardRouteImport.update({
            id: '/rank-dashboard',path: '/rank-dashboard',getParentRoute: () => ToolsRoute
          })
const TranslationIndexRoute = TranslationIndexRouteImport.update({
            id: '/translation/',path: '/translation/',getParentRoute: () => rootRouteImport
          })
const TranslationLangRoute = TranslationLangRouteImport.update({
            id: '/translation/$lang',path: '/translation/$lang',getParentRoute: () => rootRouteImport
          })
const BangkokDistrictIndexRoute = BangkokDistrictIndexRouteImport.update({
            id: '/bangkok/$district/',path: '/bangkok/$district/',getParentRoute: () => rootRouteImport
          })
const BangkokDistrictServiceRoute = BangkokDistrictServiceRouteImport.update({
            id: '/bangkok/$district/$service',path: '/bangkok/$district/$service',getParentRoute: () => rootRouteImport
          })
const BusinessFaqIndexRoute = BusinessFaqIndexRouteImport.update({
            id: '/business/faq/',path: '/business/faq/',getParentRoute: () => rootRouteImport
          })
const BusinessFaqCategoryRoute = BusinessFaqCategoryRouteImport.update({
            id: '/business/faq/$category',path: '/business/faq/$category',getParentRoute: () => rootRouteImport
          })
const CivilRegistryFaqIndexRoute = CivilRegistryFaqIndexRouteImport.update({
            id: '/civil-registry/faq/',path: '/civil-registry/faq/',getParentRoute: () => rootRouteImport
          })
const CivilRegistryFaqCategoryRoute = CivilRegistryFaqCategoryRouteImport.update({
            id: '/civil-registry/faq/$category',path: '/civil-registry/faq/$category',getParentRoute: () => rootRouteImport
          })
const CompanyFaqIndexRoute = CompanyFaqIndexRouteImport.update({
            id: '/company/faq/',path: '/company/faq/',getParentRoute: () => rootRouteImport
          })
const CompanyFaqCategoryRoute = CompanyFaqCategoryRouteImport.update({
            id: '/company/faq/$category',path: '/company/faq/$category',getParentRoute: () => rootRouteImport
          })
const CompanyTypeIndexRoute = CompanyTypeIndexRouteImport.update({
            id: '/company/type/',path: '/company/type/',getParentRoute: () => rootRouteImport
          })
const CompanyTypeTypeRoute = CompanyTypeTypeRouteImport.update({
            id: '/company/type/$type',path: '/company/type/$type',getParentRoute: () => rootRouteImport
          })
const ConsularLegalizationCountryCountryRoute = ConsularLegalizationCountryCountryRouteImport.update({
            id: '/consular-legalization/country/$country',path: '/consular-legalization/country/$country',getParentRoute: () => rootRouteImport
          })
const ConsularLegalizationDocumentDocRoute = ConsularLegalizationDocumentDocRouteImport.update({
            id: '/consular-legalization/document/$doc',path: '/consular-legalization/document/$doc',getParentRoute: () => rootRouteImport
          })
const ConsularLegalizationFaqIndexRoute = ConsularLegalizationFaqIndexRouteImport.update({
            id: '/consular-legalization/faq/',path: '/consular-legalization/faq/',getParentRoute: () => rootRouteImport
          })
const ConsularLegalizationFaqCategoryRoute = ConsularLegalizationFaqCategoryRouteImport.update({
            id: '/consular-legalization/faq/$category',path: '/consular-legalization/faq/$category',getParentRoute: () => rootRouteImport
          })
const CorporateDocsFaqIndexRoute = CorporateDocsFaqIndexRouteImport.update({
            id: '/corporate-docs/faq/',path: '/corporate-docs/faq/',getParentRoute: () => rootRouteImport
          })
const CorporateDocsFaqCategoryRoute = CorporateDocsFaqCategoryRouteImport.update({
            id: '/corporate-docs/faq/$category',path: '/corporate-docs/faq/$category',getParentRoute: () => rootRouteImport
          })
const CountriesCountryIndexRoute = CountriesCountryIndexRouteImport.update({
            id: '/countries/$country/',path: '/countries/$country/',getParentRoute: () => rootRouteImport
          })
const CountriesCountryServiceRoute = CountriesCountryServiceRouteImport.update({
            id: '/countries/$country/$service',path: '/countries/$country/$service',getParentRoute: () => rootRouteImport
          })
const DrivingFaqIndexRoute = DrivingFaqIndexRouteImport.update({
            id: '/driving/faq/',path: '/driving/faq/',getParentRoute: () => rootRouteImport
          })
const DrivingFaqCategoryRoute = DrivingFaqCategoryRouteImport.update({
            id: '/driving/faq/$category',path: '/driving/faq/$category',getParentRoute: () => rootRouteImport
          })
const EducationFaqIndexRoute = EducationFaqIndexRouteImport.update({
            id: '/education/faq/',path: '/education/faq/',getParentRoute: () => rootRouteImport
          })
const EducationFaqCategoryRoute = EducationFaqCategoryRouteImport.update({
            id: '/education/faq/$category',path: '/education/faq/$category',getParentRoute: () => rootRouteImport
          })
const EmploymentFaqIndexRoute = EmploymentFaqIndexRouteImport.update({
            id: '/employment/faq/',path: '/employment/faq/',getParentRoute: () => rootRouteImport
          })
const EmploymentFaqCategoryRoute = EmploymentFaqCategoryRouteImport.update({
            id: '/employment/faq/$category',path: '/employment/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnConsularLegalizationIndexRoute = EnConsularLegalizationIndexRouteImport.update({
            id: '/en/consular-legalization/',path: '/en/consular-legalization/',getParentRoute: () => rootRouteImport
          })
const EnInsightsIndexRoute = EnInsightsIndexRouteImport.update({
            id: '/en/insights/',path: '/en/insights/',getParentRoute: () => rootRouteImport
          })
const EnInsightsSlugRoute = EnInsightsSlugRouteImport.update({
            id: '/en/insights/$slug',path: '/en/insights/$slug',getParentRoute: () => rootRouteImport
          })
const EnNaatiIndexRoute = EnNaatiIndexRouteImport.update({
            id: '/en/naati/',path: '/en/naati/',getParentRoute: () => rootRouteImport
          })
const EnNotaryIndexRoute = EnNotaryIndexRouteImport.update({
            id: '/en/notary/',path: '/en/notary/',getParentRoute: () => rootRouteImport
          })
const EnPoaIndexRoute = EnPoaIndexRouteImport.update({
            id: '/en/poa/',path: '/en/poa/',getParentRoute: () => rootRouteImport
          })
const EnPoliceClearanceIndexRoute = EnPoliceClearanceIndexRouteImport.update({
            id: '/en/police-clearance/',path: '/en/police-clearance/',getParentRoute: () => rootRouteImport
          })
const EnPoliceClearanceCountryRoute = EnPoliceClearanceCountryRouteImport.update({
            id: '/en/police-clearance/$country',path: '/en/police-clearance/$country',getParentRoute: () => rootRouteImport
          })
const EnServicesIndexRoute = EnServicesIndexRouteImport.update({
            id: '/en/services/',path: '/en/services/',getParentRoute: () => rootRouteImport
          })
const EnServicesServiceRoute = EnServicesServiceRouteImport.update({
            id: '/en/services/$service',path: '/en/services/$service',getParentRoute: () => rootRouteImport
          })
const EnTranslationIndexRoute = EnTranslationIndexRouteImport.update({
            id: '/en/translation/',path: '/en/translation/',getParentRoute: () => rootRouteImport
          })
const IndustrialEstatesEstateIndexRoute = IndustrialEstatesEstateIndexRouteImport.update({
            id: '/industrial-estates/$estate/',path: '/industrial-estates/$estate/',getParentRoute: () => rootRouteImport
          })
const IndustrialEstatesEstateServiceRoute = IndustrialEstatesEstateServiceRouteImport.update({
            id: '/industrial-estates/$estate/$service',path: '/industrial-estates/$estate/$service',getParentRoute: () => rootRouteImport
          })
const InheritanceFaqIndexRoute = InheritanceFaqIndexRouteImport.update({
            id: '/inheritance/faq/',path: '/inheritance/faq/',getParentRoute: () => rootRouteImport
          })
const InheritanceFaqCategoryRoute = InheritanceFaqCategoryRouteImport.update({
            id: '/inheritance/faq/$category',path: '/inheritance/faq/$category',getParentRoute: () => rootRouteImport
          })
const InsuranceFaqIndexRoute = InsuranceFaqIndexRouteImport.update({
            id: '/insurance/faq/',path: '/insurance/faq/',getParentRoute: () => rootRouteImport
          })
const InsuranceFaqCategoryRoute = InsuranceFaqCategoryRouteImport.update({
            id: '/insurance/faq/$category',path: '/insurance/faq/$category',getParentRoute: () => rootRouteImport
          })
const InterpreterFaqIndexRoute = InterpreterFaqIndexRouteImport.update({
            id: '/interpreter/faq/',path: '/interpreter/faq/',getParentRoute: () => rootRouteImport
          })
const InterpreterFaqCategoryRoute = InterpreterFaqCategoryRouteImport.update({
            id: '/interpreter/faq/$category',path: '/interpreter/faq/$category',getParentRoute: () => rootRouteImport
          })
const IpFaqIndexRoute = IpFaqIndexRouteImport.update({
            id: '/ip/faq/',path: '/ip/faq/',getParentRoute: () => rootRouteImport
          })
const IpFaqCategoryRoute = IpFaqCategoryRouteImport.update({
            id: '/ip/faq/$category',path: '/ip/faq/$category',getParentRoute: () => rootRouteImport
          })
const LegalFaqIndexRoute = LegalFaqIndexRouteImport.update({
            id: '/legal/faq/',path: '/legal/faq/',getParentRoute: () => rootRouteImport
          })
const LegalFaqCategoryRoute = LegalFaqCategoryRouteImport.update({
            id: '/legal/faq/$category',path: '/legal/faq/$category',getParentRoute: () => rootRouteImport
          })
const MarriageFaqIndexRoute = MarriageFaqIndexRouteImport.update({
            id: '/marriage/faq/',path: '/marriage/faq/',getParentRoute: () => rootRouteImport
          })
const MarriageFaqCategoryRoute = MarriageFaqCategoryRouteImport.update({
            id: '/marriage/faq/$category',path: '/marriage/faq/$category',getParentRoute: () => rootRouteImport
          })
const MedicalFaqIndexRoute = MedicalFaqIndexRouteImport.update({
            id: '/medical/faq/',path: '/medical/faq/',getParentRoute: () => rootRouteImport
          })
const MedicalFaqCategoryRoute = MedicalFaqCategoryRouteImport.update({
            id: '/medical/faq/$category',path: '/medical/faq/$category',getParentRoute: () => rootRouteImport
          })
const NaatiDocumentDocRoute = NaatiDocumentDocRouteImport.update({
            id: '/naati/document/$doc',path: '/naati/document/$doc',getParentRoute: () => rootRouteImport
          })
const NaatiFaqIndexRoute = NaatiFaqIndexRouteImport.update({
            id: '/naati/faq/',path: '/naati/faq/',getParentRoute: () => rootRouteImport
          })
const NaatiFaqCategoryRoute = NaatiFaqCategoryRouteImport.update({
            id: '/naati/faq/$category',path: '/naati/faq/$category',getParentRoute: () => rootRouteImport
          })
const NaatiProvinceProvinceRoute = NaatiProvinceProvinceRouteImport.update({
            id: '/naati/province/$province',path: '/naati/province/$province',getParentRoute: () => rootRouteImport
          })
const NaatiVisaSubclassRoute = NaatiVisaSubclassRouteImport.update({
            id: '/naati/visa/$subclass',path: '/naati/visa/$subclass',getParentRoute: () => rootRouteImport
          })
const NotaryCountryCountryRoute = NotaryCountryCountryRouteImport.update({
            id: '/notary/country/$country',path: '/notary/country/$country',getParentRoute: () => rootRouteImport
          })
const NotaryDocumentDocRoute = NotaryDocumentDocRouteImport.update({
            id: '/notary/document/$doc',path: '/notary/document/$doc',getParentRoute: () => rootRouteImport
          })
const NotaryFaqIndexRoute = NotaryFaqIndexRouteImport.update({
            id: '/notary/faq/',path: '/notary/faq/',getParentRoute: () => rootRouteImport
          })
const NotaryFaqCategoryRoute = NotaryFaqCategoryRouteImport.update({
            id: '/notary/faq/$category',path: '/notary/faq/$category',getParentRoute: () => rootRouteImport
          })
const NotaryProvinceProvinceRoute = NotaryProvinceProvinceRouteImport.update({
            id: '/notary/province/$province',path: '/notary/province/$province',getParentRoute: () => rootRouteImport
          })
const PensionFaqIndexRoute = PensionFaqIndexRouteImport.update({
            id: '/pension/faq/',path: '/pension/faq/',getParentRoute: () => rootRouteImport
          })
const PensionFaqCategoryRoute = PensionFaqCategoryRouteImport.update({
            id: '/pension/faq/$category',path: '/pension/faq/$category',getParentRoute: () => rootRouteImport
          })
const PoaFaqIndexRoute = PoaFaqIndexRouteImport.update({
            id: '/poa/faq/',path: '/poa/faq/',getParentRoute: () => rootRouteImport
          })
const PoaFaqCategoryRoute = PoaFaqCategoryRouteImport.update({
            id: '/poa/faq/$category',path: '/poa/faq/$category',getParentRoute: () => rootRouteImport
          })
const PoaJurisdictionCountryRoute = PoaJurisdictionCountryRouteImport.update({
            id: '/poa/jurisdiction/$country',path: '/poa/jurisdiction/$country',getParentRoute: () => rootRouteImport
          })
const PoliceClearanceFaqIndexRoute = PoliceClearanceFaqIndexRouteImport.update({
            id: '/police-clearance/faq/',path: '/police-clearance/faq/',getParentRoute: () => rootRouteImport
          })
const PoliceClearanceFaqCategoryRoute = PoliceClearanceFaqCategoryRouteImport.update({
            id: '/police-clearance/faq/$category',path: '/police-clearance/faq/$category',getParentRoute: () => rootRouteImport
          })
const PoliceClearanceProvinceProvinceRoute = PoliceClearanceProvinceProvinceRouteImport.update({
            id: '/police-clearance/province/$province',path: '/police-clearance/province/$province',getParentRoute: () => rootRouteImport
          })
const PropertyFaqIndexRoute = PropertyFaqIndexRouteImport.update({
            id: '/property/faq/',path: '/property/faq/',getParentRoute: () => rootRouteImport
          })
const PropertyFaqCategoryRoute = PropertyFaqCategoryRouteImport.update({
            id: '/property/faq/$category',path: '/property/faq/$category',getParentRoute: () => rootRouteImport
          })
const ProvincesProvinceIndexRoute = ProvincesProvinceIndexRouteImport.update({
            id: '/provinces/$province/',path: '/provinces/$province/',getParentRoute: () => rootRouteImport
          })
const ProvincesProvinceServiceRoute = ProvincesProvinceServiceRouteImport.update({
            id: '/provinces/$province/$service',path: '/provinces/$province/$service',getParentRoute: () => rootRouteImport
          })
const RecommendHubIndexRoute = RecommendHubIndexRouteImport.update({
            id: '/recommend/$hub/',path: '/recommend/$hub/',getParentRoute: () => rootRouteImport
          })
const RecommendHubTopicRoute = RecommendHubTopicRouteImport.update({
            id: '/recommend/$hub/$topic',path: '/recommend/$hub/$topic',getParentRoute: () => rootRouteImport
          })
const RelocationFaqIndexRoute = RelocationFaqIndexRouteImport.update({
            id: '/relocation/faq/',path: '/relocation/faq/',getParentRoute: () => rootRouteImport
          })
const RelocationFaqCategoryRoute = RelocationFaqCategoryRouteImport.update({
            id: '/relocation/faq/$category',path: '/relocation/faq/$category',getParentRoute: () => rootRouteImport
          })
const TaxFaqIndexRoute = TaxFaqIndexRouteImport.update({
            id: '/tax/faq/',path: '/tax/faq/',getParentRoute: () => rootRouteImport
          })
const TaxFaqCategoryRoute = TaxFaqCategoryRouteImport.update({
            id: '/tax/faq/$category',path: '/tax/faq/$category',getParentRoute: () => rootRouteImport
          })
const TranslationCountryCountryRoute = TranslationCountryCountryRouteImport.update({
            id: '/translation/country/$country',path: '/translation/country/$country',getParentRoute: () => rootRouteImport
          })
const TranslationDocumentDocRoute = TranslationDocumentDocRouteImport.update({
            id: '/translation/document/$doc',path: '/translation/document/$doc',getParentRoute: () => rootRouteImport
          })
const TranslationFaqIndexRoute = TranslationFaqIndexRouteImport.update({
            id: '/translation/faq/',path: '/translation/faq/',getParentRoute: () => rootRouteImport
          })
const TranslationFaqCategoryRoute = TranslationFaqCategoryRouteImport.update({
            id: '/translation/faq/$category',path: '/translation/faq/$category',getParentRoute: () => rootRouteImport
          })
const VehicleFaqIndexRoute = VehicleFaqIndexRouteImport.update({
            id: '/vehicle/faq/',path: '/vehicle/faq/',getParentRoute: () => rootRouteImport
          })
const VehicleFaqCategoryRoute = VehicleFaqCategoryRouteImport.update({
            id: '/vehicle/faq/$category',path: '/vehicle/faq/$category',getParentRoute: () => rootRouteImport
          })
const VisaFaqIndexRoute = VisaFaqIndexRouteImport.update({
            id: '/visa/faq/',path: '/visa/faq/',getParentRoute: () => rootRouteImport
          })
const VisaFaqCategoryRoute = VisaFaqCategoryRouteImport.update({
            id: '/visa/faq/$category',path: '/visa/faq/$category',getParentRoute: () => rootRouteImport
          })
const VisaThaiIndexRoute = VisaThaiIndexRouteImport.update({
            id: '/visa/thai/',path: '/visa/thai/',getParentRoute: () => rootRouteImport
          })
const VisaThaiTypeRoute = VisaThaiTypeRouteImport.update({
            id: '/visa/thai/$type',path: '/visa/thai/$type',getParentRoute: () => rootRouteImport
          })
const WorkPermitFaqIndexRoute = WorkPermitFaqIndexRouteImport.update({
            id: '/work-permit/faq/',path: '/work-permit/faq/',getParentRoute: () => rootRouteImport
          })
const WorkPermitFaqCategoryRoute = WorkPermitFaqCategoryRouteImport.update({
            id: '/work-permit/faq/$category',path: '/work-permit/faq/$category',getParentRoute: () => rootRouteImport
          })
const WorkPermitTypeIndexRoute = WorkPermitTypeIndexRouteImport.update({
            id: '/work-permit/type/',path: '/work-permit/type/',getParentRoute: () => rootRouteImport
          })
const WorkPermitTypeTypeRoute = WorkPermitTypeTypeRouteImport.update({
            id: '/work-permit/type/$type',path: '/work-permit/type/$type',getParentRoute: () => rootRouteImport
          })
const EnBusinessFaqIndexRoute = EnBusinessFaqIndexRouteImport.update({
            id: '/en/business/faq/',path: '/en/business/faq/',getParentRoute: () => rootRouteImport
          })
const EnBusinessFaqCategoryRoute = EnBusinessFaqCategoryRouteImport.update({
            id: '/en/business/faq/$category',path: '/en/business/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnCivilRegistryFaqIndexRoute = EnCivilRegistryFaqIndexRouteImport.update({
            id: '/en/civil-registry/faq/',path: '/en/civil-registry/faq/',getParentRoute: () => rootRouteImport
          })
const EnCivilRegistryFaqCategoryRoute = EnCivilRegistryFaqCategoryRouteImport.update({
            id: '/en/civil-registry/faq/$category',path: '/en/civil-registry/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnCompanyFaqIndexRoute = EnCompanyFaqIndexRouteImport.update({
            id: '/en/company/faq/',path: '/en/company/faq/',getParentRoute: () => rootRouteImport
          })
const EnCompanyFaqCategoryRoute = EnCompanyFaqCategoryRouteImport.update({
            id: '/en/company/faq/$category',path: '/en/company/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnCompanyTypeIndexRoute = EnCompanyTypeIndexRouteImport.update({
            id: '/en/company/type/',path: '/en/company/type/',getParentRoute: () => rootRouteImport
          })
const EnCompanyTypeTypeRoute = EnCompanyTypeTypeRouteImport.update({
            id: '/en/company/type/$type',path: '/en/company/type/$type',getParentRoute: () => rootRouteImport
          })
const EnConsularLegalizationCountryCountryRoute = EnConsularLegalizationCountryCountryRouteImport.update({
            id: '/en/consular-legalization/country/$country',path: '/en/consular-legalization/country/$country',getParentRoute: () => rootRouteImport
          })
const EnConsularLegalizationDocumentDocRoute = EnConsularLegalizationDocumentDocRouteImport.update({
            id: '/en/consular-legalization/document/$doc',path: '/en/consular-legalization/document/$doc',getParentRoute: () => rootRouteImport
          })
const EnConsularLegalizationFaqIndexRoute = EnConsularLegalizationFaqIndexRouteImport.update({
            id: '/en/consular-legalization/faq/',path: '/en/consular-legalization/faq/',getParentRoute: () => rootRouteImport
          })
const EnConsularLegalizationFaqCategoryRoute = EnConsularLegalizationFaqCategoryRouteImport.update({
            id: '/en/consular-legalization/faq/$category',path: '/en/consular-legalization/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnCorporateDocsFaqIndexRoute = EnCorporateDocsFaqIndexRouteImport.update({
            id: '/en/corporate-docs/faq/',path: '/en/corporate-docs/faq/',getParentRoute: () => rootRouteImport
          })
const EnCorporateDocsFaqCategoryRoute = EnCorporateDocsFaqCategoryRouteImport.update({
            id: '/en/corporate-docs/faq/$category',path: '/en/corporate-docs/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnDrivingFaqIndexRoute = EnDrivingFaqIndexRouteImport.update({
            id: '/en/driving/faq/',path: '/en/driving/faq/',getParentRoute: () => rootRouteImport
          })
const EnDrivingFaqCategoryRoute = EnDrivingFaqCategoryRouteImport.update({
            id: '/en/driving/faq/$category',path: '/en/driving/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnEducationFaqIndexRoute = EnEducationFaqIndexRouteImport.update({
            id: '/en/education/faq/',path: '/en/education/faq/',getParentRoute: () => rootRouteImport
          })
const EnEducationFaqCategoryRoute = EnEducationFaqCategoryRouteImport.update({
            id: '/en/education/faq/$category',path: '/en/education/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnEmploymentFaqIndexRoute = EnEmploymentFaqIndexRouteImport.update({
            id: '/en/employment/faq/',path: '/en/employment/faq/',getParentRoute: () => rootRouteImport
          })
const EnEmploymentFaqCategoryRoute = EnEmploymentFaqCategoryRouteImport.update({
            id: '/en/employment/faq/$category',path: '/en/employment/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnInheritanceFaqIndexRoute = EnInheritanceFaqIndexRouteImport.update({
            id: '/en/inheritance/faq/',path: '/en/inheritance/faq/',getParentRoute: () => rootRouteImport
          })
const EnInheritanceFaqCategoryRoute = EnInheritanceFaqCategoryRouteImport.update({
            id: '/en/inheritance/faq/$category',path: '/en/inheritance/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnInsuranceFaqIndexRoute = EnInsuranceFaqIndexRouteImport.update({
            id: '/en/insurance/faq/',path: '/en/insurance/faq/',getParentRoute: () => rootRouteImport
          })
const EnInsuranceFaqCategoryRoute = EnInsuranceFaqCategoryRouteImport.update({
            id: '/en/insurance/faq/$category',path: '/en/insurance/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnInterpreterFaqIndexRoute = EnInterpreterFaqIndexRouteImport.update({
            id: '/en/interpreter/faq/',path: '/en/interpreter/faq/',getParentRoute: () => rootRouteImport
          })
const EnInterpreterFaqCategoryRoute = EnInterpreterFaqCategoryRouteImport.update({
            id: '/en/interpreter/faq/$category',path: '/en/interpreter/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnIpFaqIndexRoute = EnIpFaqIndexRouteImport.update({
            id: '/en/ip/faq/',path: '/en/ip/faq/',getParentRoute: () => rootRouteImport
          })
const EnIpFaqCategoryRoute = EnIpFaqCategoryRouteImport.update({
            id: '/en/ip/faq/$category',path: '/en/ip/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnLegalFaqIndexRoute = EnLegalFaqIndexRouteImport.update({
            id: '/en/legal/faq/',path: '/en/legal/faq/',getParentRoute: () => rootRouteImport
          })
const EnLegalFaqCategoryRoute = EnLegalFaqCategoryRouteImport.update({
            id: '/en/legal/faq/$category',path: '/en/legal/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnMarriageFaqIndexRoute = EnMarriageFaqIndexRouteImport.update({
            id: '/en/marriage/faq/',path: '/en/marriage/faq/',getParentRoute: () => rootRouteImport
          })
const EnMarriageFaqCategoryRoute = EnMarriageFaqCategoryRouteImport.update({
            id: '/en/marriage/faq/$category',path: '/en/marriage/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnMedicalFaqIndexRoute = EnMedicalFaqIndexRouteImport.update({
            id: '/en/medical/faq/',path: '/en/medical/faq/',getParentRoute: () => rootRouteImport
          })
const EnMedicalFaqCategoryRoute = EnMedicalFaqCategoryRouteImport.update({
            id: '/en/medical/faq/$category',path: '/en/medical/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnNaatiDocumentDocRoute = EnNaatiDocumentDocRouteImport.update({
            id: '/en/naati/document/$doc',path: '/en/naati/document/$doc',getParentRoute: () => rootRouteImport
          })
const EnNaatiFaqIndexRoute = EnNaatiFaqIndexRouteImport.update({
            id: '/en/naati/faq/',path: '/en/naati/faq/',getParentRoute: () => rootRouteImport
          })
const EnNaatiFaqCategoryRoute = EnNaatiFaqCategoryRouteImport.update({
            id: '/en/naati/faq/$category',path: '/en/naati/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnNaatiProvinceProvinceRoute = EnNaatiProvinceProvinceRouteImport.update({
            id: '/en/naati/province/$province',path: '/en/naati/province/$province',getParentRoute: () => rootRouteImport
          })
const EnNaatiVisaSubclassRoute = EnNaatiVisaSubclassRouteImport.update({
            id: '/en/naati/visa/$subclass',path: '/en/naati/visa/$subclass',getParentRoute: () => rootRouteImport
          })
const EnNotaryCountryCountryRoute = EnNotaryCountryCountryRouteImport.update({
            id: '/en/notary/country/$country',path: '/en/notary/country/$country',getParentRoute: () => rootRouteImport
          })
const EnNotaryDocumentDocRoute = EnNotaryDocumentDocRouteImport.update({
            id: '/en/notary/document/$doc',path: '/en/notary/document/$doc',getParentRoute: () => rootRouteImport
          })
const EnNotaryFaqIndexRoute = EnNotaryFaqIndexRouteImport.update({
            id: '/en/notary/faq/',path: '/en/notary/faq/',getParentRoute: () => rootRouteImport
          })
const EnNotaryFaqCategoryRoute = EnNotaryFaqCategoryRouteImport.update({
            id: '/en/notary/faq/$category',path: '/en/notary/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnNotaryProvinceProvinceRoute = EnNotaryProvinceProvinceRouteImport.update({
            id: '/en/notary/province/$province',path: '/en/notary/province/$province',getParentRoute: () => rootRouteImport
          })
const EnPensionFaqIndexRoute = EnPensionFaqIndexRouteImport.update({
            id: '/en/pension/faq/',path: '/en/pension/faq/',getParentRoute: () => rootRouteImport
          })
const EnPensionFaqCategoryRoute = EnPensionFaqCategoryRouteImport.update({
            id: '/en/pension/faq/$category',path: '/en/pension/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnPoaFaqIndexRoute = EnPoaFaqIndexRouteImport.update({
            id: '/en/poa/faq/',path: '/en/poa/faq/',getParentRoute: () => rootRouteImport
          })
const EnPoaFaqCategoryRoute = EnPoaFaqCategoryRouteImport.update({
            id: '/en/poa/faq/$category',path: '/en/poa/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnPoaJurisdictionCountryRoute = EnPoaJurisdictionCountryRouteImport.update({
            id: '/en/poa/jurisdiction/$country',path: '/en/poa/jurisdiction/$country',getParentRoute: () => rootRouteImport
          })
const EnPoliceClearanceFaqIndexRoute = EnPoliceClearanceFaqIndexRouteImport.update({
            id: '/en/police-clearance/faq/',path: '/en/police-clearance/faq/',getParentRoute: () => rootRouteImport
          })
const EnPoliceClearanceFaqCategoryRoute = EnPoliceClearanceFaqCategoryRouteImport.update({
            id: '/en/police-clearance/faq/$category',path: '/en/police-clearance/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnPoliceClearanceProvinceProvinceRoute = EnPoliceClearanceProvinceProvinceRouteImport.update({
            id: '/en/police-clearance/province/$province',path: '/en/police-clearance/province/$province',getParentRoute: () => rootRouteImport
          })
const EnPropertyFaqIndexRoute = EnPropertyFaqIndexRouteImport.update({
            id: '/en/property/faq/',path: '/en/property/faq/',getParentRoute: () => rootRouteImport
          })
const EnPropertyFaqCategoryRoute = EnPropertyFaqCategoryRouteImport.update({
            id: '/en/property/faq/$category',path: '/en/property/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnRelocationFaqIndexRoute = EnRelocationFaqIndexRouteImport.update({
            id: '/en/relocation/faq/',path: '/en/relocation/faq/',getParentRoute: () => rootRouteImport
          })
const EnRelocationFaqCategoryRoute = EnRelocationFaqCategoryRouteImport.update({
            id: '/en/relocation/faq/$category',path: '/en/relocation/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnTaxFaqIndexRoute = EnTaxFaqIndexRouteImport.update({
            id: '/en/tax/faq/',path: '/en/tax/faq/',getParentRoute: () => rootRouteImport
          })
const EnTaxFaqCategoryRoute = EnTaxFaqCategoryRouteImport.update({
            id: '/en/tax/faq/$category',path: '/en/tax/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnTranslationCountryCountryRoute = EnTranslationCountryCountryRouteImport.update({
            id: '/en/translation/country/$country',path: '/en/translation/country/$country',getParentRoute: () => rootRouteImport
          })
const EnTranslationDocumentDocRoute = EnTranslationDocumentDocRouteImport.update({
            id: '/en/translation/document/$doc',path: '/en/translation/document/$doc',getParentRoute: () => rootRouteImport
          })
const EnTranslationFaqIndexRoute = EnTranslationFaqIndexRouteImport.update({
            id: '/en/translation/faq/',path: '/en/translation/faq/',getParentRoute: () => rootRouteImport
          })
const EnTranslationFaqCategoryRoute = EnTranslationFaqCategoryRouteImport.update({
            id: '/en/translation/faq/$category',path: '/en/translation/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnVehicleFaqIndexRoute = EnVehicleFaqIndexRouteImport.update({
            id: '/en/vehicle/faq/',path: '/en/vehicle/faq/',getParentRoute: () => rootRouteImport
          })
const EnVehicleFaqCategoryRoute = EnVehicleFaqCategoryRouteImport.update({
            id: '/en/vehicle/faq/$category',path: '/en/vehicle/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnVisaFaqIndexRoute = EnVisaFaqIndexRouteImport.update({
            id: '/en/visa/faq/',path: '/en/visa/faq/',getParentRoute: () => rootRouteImport
          })
const EnVisaFaqCategoryRoute = EnVisaFaqCategoryRouteImport.update({
            id: '/en/visa/faq/$category',path: '/en/visa/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnVisaThaiIndexRoute = EnVisaThaiIndexRouteImport.update({
            id: '/en/visa/thai/',path: '/en/visa/thai/',getParentRoute: () => rootRouteImport
          })
const EnVisaThaiTypeRoute = EnVisaThaiTypeRouteImport.update({
            id: '/en/visa/thai/$type',path: '/en/visa/thai/$type',getParentRoute: () => rootRouteImport
          })
const EnWorkPermitFaqIndexRoute = EnWorkPermitFaqIndexRouteImport.update({
            id: '/en/work-permit/faq/',path: '/en/work-permit/faq/',getParentRoute: () => rootRouteImport
          })
const EnWorkPermitFaqCategoryRoute = EnWorkPermitFaqCategoryRouteImport.update({
            id: '/en/work-permit/faq/$category',path: '/en/work-permit/faq/$category',getParentRoute: () => rootRouteImport
          })
const EnWorkPermitTypeIndexRoute = EnWorkPermitTypeIndexRouteImport.update({
            id: '/en/work-permit/type/',path: '/en/work-permit/type/',getParentRoute: () => rootRouteImport
          })
const EnWorkPermitTypeTypeRoute = EnWorkPermitTypeTypeRouteImport.update({
            id: '/en/work-permit/type/$type',path: '/en/work-permit/type/$type',getParentRoute: () => rootRouteImport
          })





const ToolsRouteChildren = {
  ToolsRankDashboardRoute: ToolsRankDashboardRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CatalogRoute: CatalogRoute,ContactRoute: ContactRoute,PricingRoute: PricingRoute,PricingMatrixRoute: PricingMatrixRoute,PrivacyRoute: PrivacyRoute,ReviewsRoute: ReviewsRoute,SitemapHtmlRoute: SitemapHtmlRoute,TermsRoute: TermsRoute,ToolsRoute: ToolsRouteWithChildren,AreasAreaRoute: AreasAreaRoute,CaseStudiesSlugRoute: CaseStudiesSlugRoute,CompareSlugRoute: CompareSlugRoute,EmbassiesCodeRoute: EmbassiesCodeRoute,EnCatalogRoute: EnCatalogRoute,ForSegmentRoute: ForSegmentRoute,GlossaryTermRoute: GlossaryTermRoute,HowtoSlugRoute: HowtoSlugRoute,InsightsSlugRoute: InsightsSlugRoute,LocationsBranchRoute: LocationsBranchRoute,NearPlaceRoute: NearPlaceRoute,PoliceClearanceCountryRoute: PoliceClearanceCountryRoute,ServicesServiceRoute: ServicesServiceRoute,TranslationLangRoute: TranslationLangRoute,AreasIndexRoute: AreasIndexRoute,BangkokIndexRoute: BangkokIndexRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute,CompareIndexRoute: CompareIndexRoute,ConsularLegalizationIndexRoute: ConsularLegalizationIndexRoute,CountriesIndexRoute: CountriesIndexRoute,EmbassiesIndexRoute: EmbassiesIndexRoute,EnIndexRoute: EnIndexRoute,ForIndexRoute: ForIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,HowtoIndexRoute: HowtoIndexRoute,IndustrialEstatesIndexRoute: IndustrialEstatesIndexRoute,InsightsIndexRoute: InsightsIndexRoute,LocationsIndexRoute: LocationsIndexRoute,NaatiIndexRoute: NaatiIndexRoute,NearIndexRoute: NearIndexRoute,NotaryIndexRoute: NotaryIndexRoute,PoaIndexRoute: PoaIndexRoute,PoliceClearanceIndexRoute: PoliceClearanceIndexRoute,ProvincesIndexRoute: ProvincesIndexRoute,RecommendIndexRoute: RecommendIndexRoute,ServicesIndexRoute: ServicesIndexRoute,TranslationIndexRoute: TranslationIndexRoute,BangkokDistrictServiceRoute: BangkokDistrictServiceRoute,BusinessFaqCategoryRoute: BusinessFaqCategoryRoute,CivilRegistryFaqCategoryRoute: CivilRegistryFaqCategoryRoute,CompanyFaqCategoryRoute: CompanyFaqCategoryRoute,CompanyTypeTypeRoute: CompanyTypeTypeRoute,ConsularLegalizationCountryCountryRoute: ConsularLegalizationCountryCountryRoute,ConsularLegalizationDocumentDocRoute: ConsularLegalizationDocumentDocRoute,ConsularLegalizationFaqCategoryRoute: ConsularLegalizationFaqCategoryRoute,CorporateDocsFaqCategoryRoute: CorporateDocsFaqCategoryRoute,CountriesCountryServiceRoute: CountriesCountryServiceRoute,DrivingFaqCategoryRoute: DrivingFaqCategoryRoute,EducationFaqCategoryRoute: EducationFaqCategoryRoute,EmploymentFaqCategoryRoute: EmploymentFaqCategoryRoute,EnInsightsSlugRoute: EnInsightsSlugRoute,EnPoliceClearanceCountryRoute: EnPoliceClearanceCountryRoute,EnServicesServiceRoute: EnServicesServiceRoute,IndustrialEstatesEstateServiceRoute: IndustrialEstatesEstateServiceRoute,InheritanceFaqCategoryRoute: InheritanceFaqCategoryRoute,InsuranceFaqCategoryRoute: InsuranceFaqCategoryRoute,InterpreterFaqCategoryRoute: InterpreterFaqCategoryRoute,IpFaqCategoryRoute: IpFaqCategoryRoute,LegalFaqCategoryRoute: LegalFaqCategoryRoute,MarriageFaqCategoryRoute: MarriageFaqCategoryRoute,MedicalFaqCategoryRoute: MedicalFaqCategoryRoute,NaatiDocumentDocRoute: NaatiDocumentDocRoute,NaatiFaqCategoryRoute: NaatiFaqCategoryRoute,NaatiProvinceProvinceRoute: NaatiProvinceProvinceRoute,NaatiVisaSubclassRoute: NaatiVisaSubclassRoute,NotaryCountryCountryRoute: NotaryCountryCountryRoute,NotaryDocumentDocRoute: NotaryDocumentDocRoute,NotaryFaqCategoryRoute: NotaryFaqCategoryRoute,NotaryProvinceProvinceRoute: NotaryProvinceProvinceRoute,PensionFaqCategoryRoute: PensionFaqCategoryRoute,PoaFaqCategoryRoute: PoaFaqCategoryRoute,PoaJurisdictionCountryRoute: PoaJurisdictionCountryRoute,PoliceClearanceFaqCategoryRoute: PoliceClearanceFaqCategoryRoute,PoliceClearanceProvinceProvinceRoute: PoliceClearanceProvinceProvinceRoute,PropertyFaqCategoryRoute: PropertyFaqCategoryRoute,ProvincesProvinceServiceRoute: ProvincesProvinceServiceRoute,RecommendHubTopicRoute: RecommendHubTopicRoute,RelocationFaqCategoryRoute: RelocationFaqCategoryRoute,TaxFaqCategoryRoute: TaxFaqCategoryRoute,TranslationCountryCountryRoute: TranslationCountryCountryRoute,TranslationDocumentDocRoute: TranslationDocumentDocRoute,TranslationFaqCategoryRoute: TranslationFaqCategoryRoute,VehicleFaqCategoryRoute: VehicleFaqCategoryRoute,VisaFaqCategoryRoute: VisaFaqCategoryRoute,VisaThaiTypeRoute: VisaThaiTypeRoute,WorkPermitFaqCategoryRoute: WorkPermitFaqCategoryRoute,WorkPermitTypeTypeRoute: WorkPermitTypeTypeRoute,BangkokDistrictIndexRoute: BangkokDistrictIndexRoute,BusinessFaqIndexRoute: BusinessFaqIndexRoute,CivilRegistryFaqIndexRoute: CivilRegistryFaqIndexRoute,CompanyFaqIndexRoute: CompanyFaqIndexRoute,CompanyTypeIndexRoute: CompanyTypeIndexRoute,ConsularLegalizationFaqIndexRoute: ConsularLegalizationFaqIndexRoute,CorporateDocsFaqIndexRoute: CorporateDocsFaqIndexRoute,CountriesCountryIndexRoute: CountriesCountryIndexRoute,DrivingFaqIndexRoute: DrivingFaqIndexRoute,EducationFaqIndexRoute: EducationFaqIndexRoute,EmploymentFaqIndexRoute: EmploymentFaqIndexRoute,EnConsularLegalizationIndexRoute: EnConsularLegalizationIndexRoute,EnInsightsIndexRoute: EnInsightsIndexRoute,EnNaatiIndexRoute: EnNaatiIndexRoute,EnNotaryIndexRoute: EnNotaryIndexRoute,EnPoaIndexRoute: EnPoaIndexRoute,EnPoliceClearanceIndexRoute: EnPoliceClearanceIndexRoute,EnServicesIndexRoute: EnServicesIndexRoute,EnTranslationIndexRoute: EnTranslationIndexRoute,IndustrialEstatesEstateIndexRoute: IndustrialEstatesEstateIndexRoute,InheritanceFaqIndexRoute: InheritanceFaqIndexRoute,InsuranceFaqIndexRoute: InsuranceFaqIndexRoute,InterpreterFaqIndexRoute: InterpreterFaqIndexRoute,IpFaqIndexRoute: IpFaqIndexRoute,LegalFaqIndexRoute: LegalFaqIndexRoute,MarriageFaqIndexRoute: MarriageFaqIndexRoute,MedicalFaqIndexRoute: MedicalFaqIndexRoute,NaatiFaqIndexRoute: NaatiFaqIndexRoute,NotaryFaqIndexRoute: NotaryFaqIndexRoute,PensionFaqIndexRoute: PensionFaqIndexRoute,PoaFaqIndexRoute: PoaFaqIndexRoute,PoliceClearanceFaqIndexRoute: PoliceClearanceFaqIndexRoute,PropertyFaqIndexRoute: PropertyFaqIndexRoute,ProvincesProvinceIndexRoute: ProvincesProvinceIndexRoute,RecommendHubIndexRoute: RecommendHubIndexRoute,RelocationFaqIndexRoute: RelocationFaqIndexRoute,TaxFaqIndexRoute: TaxFaqIndexRoute,TranslationFaqIndexRoute: TranslationFaqIndexRoute,VehicleFaqIndexRoute: VehicleFaqIndexRoute,VisaFaqIndexRoute: VisaFaqIndexRoute,VisaThaiIndexRoute: VisaThaiIndexRoute,WorkPermitFaqIndexRoute: WorkPermitFaqIndexRoute,WorkPermitTypeIndexRoute: WorkPermitTypeIndexRoute,EnBusinessFaqCategoryRoute: EnBusinessFaqCategoryRoute,EnCivilRegistryFaqCategoryRoute: EnCivilRegistryFaqCategoryRoute,EnCompanyFaqCategoryRoute: EnCompanyFaqCategoryRoute,EnCompanyTypeTypeRoute: EnCompanyTypeTypeRoute,EnConsularLegalizationCountryCountryRoute: EnConsularLegalizationCountryCountryRoute,EnConsularLegalizationDocumentDocRoute: EnConsularLegalizationDocumentDocRoute,EnConsularLegalizationFaqCategoryRoute: EnConsularLegalizationFaqCategoryRoute,EnCorporateDocsFaqCategoryRoute: EnCorporateDocsFaqCategoryRoute,EnDrivingFaqCategoryRoute: EnDrivingFaqCategoryRoute,EnEducationFaqCategoryRoute: EnEducationFaqCategoryRoute,EnEmploymentFaqCategoryRoute: EnEmploymentFaqCategoryRoute,EnInheritanceFaqCategoryRoute: EnInheritanceFaqCategoryRoute,EnInsuranceFaqCategoryRoute: EnInsuranceFaqCategoryRoute,EnInterpreterFaqCategoryRoute: EnInterpreterFaqCategoryRoute,EnIpFaqCategoryRoute: EnIpFaqCategoryRoute,EnLegalFaqCategoryRoute: EnLegalFaqCategoryRoute,EnMarriageFaqCategoryRoute: EnMarriageFaqCategoryRoute,EnMedicalFaqCategoryRoute: EnMedicalFaqCategoryRoute,EnNaatiDocumentDocRoute: EnNaatiDocumentDocRoute,EnNaatiFaqCategoryRoute: EnNaatiFaqCategoryRoute,EnNaatiProvinceProvinceRoute: EnNaatiProvinceProvinceRoute,EnNaatiVisaSubclassRoute: EnNaatiVisaSubclassRoute,EnNotaryCountryCountryRoute: EnNotaryCountryCountryRoute,EnNotaryDocumentDocRoute: EnNotaryDocumentDocRoute,EnNotaryFaqCategoryRoute: EnNotaryFaqCategoryRoute,EnNotaryProvinceProvinceRoute: EnNotaryProvinceProvinceRoute,EnPensionFaqCategoryRoute: EnPensionFaqCategoryRoute,EnPoaFaqCategoryRoute: EnPoaFaqCategoryRoute,EnPoaJurisdictionCountryRoute: EnPoaJurisdictionCountryRoute,EnPoliceClearanceFaqCategoryRoute: EnPoliceClearanceFaqCategoryRoute,EnPoliceClearanceProvinceProvinceRoute: EnPoliceClearanceProvinceProvinceRoute,EnPropertyFaqCategoryRoute: EnPropertyFaqCategoryRoute,EnRelocationFaqCategoryRoute: EnRelocationFaqCategoryRoute,EnTaxFaqCategoryRoute: EnTaxFaqCategoryRoute,EnTranslationCountryCountryRoute: EnTranslationCountryCountryRoute,EnTranslationDocumentDocRoute: EnTranslationDocumentDocRoute,EnTranslationFaqCategoryRoute: EnTranslationFaqCategoryRoute,EnVehicleFaqCategoryRoute: EnVehicleFaqCategoryRoute,EnVisaFaqCategoryRoute: EnVisaFaqCategoryRoute,EnVisaThaiTypeRoute: EnVisaThaiTypeRoute,EnWorkPermitFaqCategoryRoute: EnWorkPermitFaqCategoryRoute,EnWorkPermitTypeTypeRoute: EnWorkPermitTypeTypeRoute,EnBusinessFaqIndexRoute: EnBusinessFaqIndexRoute,EnCivilRegistryFaqIndexRoute: EnCivilRegistryFaqIndexRoute,EnCompanyFaqIndexRoute: EnCompanyFaqIndexRoute,EnCompanyTypeIndexRoute: EnCompanyTypeIndexRoute,EnConsularLegalizationFaqIndexRoute: EnConsularLegalizationFaqIndexRoute,EnCorporateDocsFaqIndexRoute: EnCorporateDocsFaqIndexRoute,EnDrivingFaqIndexRoute: EnDrivingFaqIndexRoute,EnEducationFaqIndexRoute: EnEducationFaqIndexRoute,EnEmploymentFaqIndexRoute: EnEmploymentFaqIndexRoute,EnInheritanceFaqIndexRoute: EnInheritanceFaqIndexRoute,EnInsuranceFaqIndexRoute: EnInsuranceFaqIndexRoute,EnInterpreterFaqIndexRoute: EnInterpreterFaqIndexRoute,EnIpFaqIndexRoute: EnIpFaqIndexRoute,EnLegalFaqIndexRoute: EnLegalFaqIndexRoute,EnMarriageFaqIndexRoute: EnMarriageFaqIndexRoute,EnMedicalFaqIndexRoute: EnMedicalFaqIndexRoute,EnNaatiFaqIndexRoute: EnNaatiFaqIndexRoute,EnNotaryFaqIndexRoute: EnNotaryFaqIndexRoute,EnPensionFaqIndexRoute: EnPensionFaqIndexRoute,EnPoaFaqIndexRoute: EnPoaFaqIndexRoute,EnPoliceClearanceFaqIndexRoute: EnPoliceClearanceFaqIndexRoute,EnPropertyFaqIndexRoute: EnPropertyFaqIndexRoute,EnRelocationFaqIndexRoute: EnRelocationFaqIndexRoute,EnTaxFaqIndexRoute: EnTaxFaqIndexRoute,EnTranslationFaqIndexRoute: EnTranslationFaqIndexRoute,EnVehicleFaqIndexRoute: EnVehicleFaqIndexRoute,EnVisaFaqIndexRoute: EnVisaFaqIndexRoute,EnVisaThaiIndexRoute: EnVisaThaiIndexRoute,EnWorkPermitFaqIndexRoute: EnWorkPermitFaqIndexRoute,EnWorkPermitTypeIndexRoute: EnWorkPermitTypeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)